var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/BimEntity/ViewerRefs.ts";
import * as t from 'io-ts';
import { Urn } from '../Urn';
import { Version } from '../Version';
export var ViewerRefs = t.array(t.type({
  urn: Urn,
  externalId: t.string,
  version: Version,
  bim360ViewerId: t.union([t.string, t["null"]])
}, 'ViewerRefs'));